module.exports = __webpack_public_path__ + "static/media/oberflex-sapelli-1200x2490.1a10b8af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-sapelli-1200x2490.jpg
// module id = 1054
// module chunks = 37